import { C } from './constants';

/**
 * Thin stat bar with endpoint dot indicator.
 * 2px track, 3px fill, 9px endpoint circle.
 *
 * @param {string} label - Stat name
 * @param {number} value - Value 0-100
 * @param {string} [color=C.gold] - Bar fill color
 */
export const Bar = ({ label, value, color = C.gold }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
    <span style={{ width: 110, fontSize: 11, color: C.t2, textAlign: 'right', flexShrink: 0 }}>{label}</span>
    <div style={{ flex: 1, height: 2, background: C.border, borderRadius: 1, position: 'relative' }}>
      <div style={{
        position: 'absolute', top: -0.5, left: 0, height: 3,
        width: `${value}%`, background: color, borderRadius: 1.5,
        transition: 'width 1.2s cubic-bezier(.16,1,.3,1)',
      }}>
        <div style={{
          position: 'absolute', right: -3, top: -3,
          width: 9, height: 9, borderRadius: '50%',
          background: C.bg, border: `2px solid ${color}`,
        }} />
      </div>
    </div>
    <span style={{ width: 28, fontSize: 12, fontWeight: 500, color: C.text, textAlign: 'right', fontFamily: 'monospace' }}>{value}</span>
  </div>
);

/**
 * Alias for Bar — used in portal/table contexts.
 */
export const SubBar = Bar;
